import React from 'react';
import { COLORS } from '../../config/colors';

function ColorPickerWidget({ x = 0, y = 0, onColorSelect, colors = null, style = {} }) {

  // The active map theme may supply its own palette (e.g. chalk pastels).
  const paletteColors = Array.isArray(colors) && colors.length > 0 ? colors : COLORS;
  const numAcross = 5
  //const height = Math.ceil(COLORS.length / numAcross) * 24;

  const handleColorClick = (color) => {
    if (onColorSelect) {
      onColorSelect(color);
    }
  };


  const containerStyle = {
    position: 'absolute',
    left: x,
    top: y,
    backgroundColor: 'white',
    borderRadius: '8px',
    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
    border: '1px solid #e5e7eb',
    padding: '8px',
    zIndex: 50,
    ...style
  };

  const gridStyle = {
    display: 'grid',
    gridTemplateColumns: `repeat(${numAcross}, 1fr)`,
    gap: '4px',
    width: '128px'
  };



  const colorSquareStyle = {
    width: '20px',
    height: '20px',
    borderRadius: '4px',
    cursor: 'pointer',
    boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    transition: 'transform 0.2s, box-shadow 0.2s',
    border: '1px solid #f3f4f6',
    padding: 0
  };

  return (
    <div style={containerStyle}>
      <div style={gridStyle}>
        {paletteColors.map((color, index) => (
          <button
            key={color.slot ?? color.name ?? index}
            type="button"
            style={{
              ...colorSquareStyle,
              background: color.gradient
            }}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              handleColorClick(color);
            }}
            aria-label={`Use ${color.name}`}
            title={color.name}
          />
        ))}
      </div>
    </div>
  );
}



export { ColorPickerWidget };
